import type { NavigateFunction, NavigateOptions, To } from "react-router-dom";

// Sagas run outside the React tree and cannot use the useNavigate() hook.
// NavigationBridge registers the router's navigate function here once, so
// sagas can drive route changes after an API call resolves.
let navigate: NavigateFunction | null = null;

export function setNavigator(navigateFn: NavigateFunction): void {
  navigate = navigateFn;
}

export function navigateTo(to: To, options?: NavigateOptions): void {
  navigate?.(to, options);
}
